import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, Outlet, useParams, json } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import ReactGA from "react-ga4";

import { Container, Row, Col } from 'react-bootstrap';
import { useSpring, animated, config, easings } from '@react-spring/web'

import { SetGame } from './store.js';
import { ShowLoading, ImgGet, Static, ModalEditPf } from './util.js';
import { ImageLoader, ImgSlot } from './imgloader.js';
import { Adsense } from './ads.js';

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';

import ImgNull from './img/NoImg.png';
import ImgPlayDone from './img/PlayDone.png';



function Play() {

    const store = useSelector((state) => state);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { addImgKey, loadImgs } = ImageLoader();

    let { uid } = useParams();

    let [ref, refSet] = useState(0);
    const ans = useRef([]);
    const qz = useRef([]);

    let [imgA, imgASet] = useState(ImgNull);
    let [imgB, imgBSet] = useState(ImgNull);

    let [showFimg, showFimgSet] = useState(false);
    let [fimg, fimgSet] = useState(false);

    let [ansDisable, ansDisableSet] = useState(true);
    let [ansClick, ansClickSet] = useState(0);
    let [pfModal, pfModalSet] = useState(false);

    let idx = ans.current.length;
    let step = ans.current.length + 1;

    const startTime = useRef();

    const [aniSlot1, aniSlot1Api] = useSpring(() => ({
        from: { x: '-100%' },
        to: { x: '0%' },
        config: { duration: 1000, easing: easings.easeOutQuart },
    }));
    const [aniSlot2, aniSlot2Api] = useSpring(() => ({
        from: { x: '100%' },
        to: { x: '0%' },
        config: { duration: 1000, easing: easings.easeOutQuart },
    }));

    const [aniNowBar, aniNowBarApi] = useSpring(() => ({
        from: { opacity: 0.5 },
        to: { opacity: 1 },
        loop: { reverse: true },
        config: { duration: 1000 }
    }));



    useEffect(() => {

        if (store.game) {
            qz.current = store.game.qz;
        }
        else {
            navigate('/game/' + uid);
        }

        startTime.current = new Date().getTime();

    }, [])

    useEffect(() => {

        showFimgSet(false);

        imgASet(ImgNull);
        imgBSet(ImgNull);

        if (idx < qz.current.length) {
            if (qz.current != null) {
                console.log(qz.current);

                let keyA = GetKey(idx, 'A');
                let keyB = GetKey(idx, 'B');

                if (keyA == null && keyB == null) {
                    imgASet(null);
                    imgBSet(null);
                }
                else {
                    if (keyA != null) {
                        imgASet(keyA);
                        addImgKey(keyA);
                    }
                    if (keyB != null) {
                        imgBSet(keyB);
                        addImgKey(keyA);
                    }

                    loadImgs();
                }



                aniSlot1Api.start({
                    from: { x: '-100%' },
                    to: { x: '0%' },
                    config: { duration: 1000, easing: easings.easeOutQuart },
                });

                aniSlot2Api.start({
                    from: { x: '100%' },
                    to: { x: '0%' },
                    config: { duration: 1000, easing: easings.easeOutQuart },
                });

                aniNowBarApi.start();

                ansClickSet(0);

                ansDisableSet(false);
            }
        }


    }, [ref])

    function GetKey(idx, slot) {
        let type = slot == 'A' ? qz.current[idx][3] : qz.current[idx][4];
        if (type == 'N') return null;
        if (type == '@') return Static.ImgType.qz + uid + '_' + idx + '-' + slot;
        return Static.ImgType.lib + type + '-' + slot;
    }





    function SetImg(url, slot) {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            slot == 'A' ? imgASet(url) : imgBSet(url);
        };
    }

    function GetBtnClass(val, img) {
        let res = img ? 'fs-4' : 'fs-2'
        if (val == ansClick) return res + ' align-items-stretch flex-fill rounded-3 border border-0 text-white text-bg-primary p-3';
        return res + ' align-items-stretch flex-fill rounded-3 border border-0 text-black bg-gray p-3';
    }


    function ClickAns(val) {

        // aniSlot1Api.start({
        //     from: {
        //         width: '0%',
        //         x: '0%'
        //     },
        //     to: {
        //         width: '100%',
        //         x: '-100%' 
        //     },
        //     config: {
        //         duration: 1000,
        //         easing: easings.easeOutQuart
        //       },
        // });

        // aniSlot2Api.start({
        //     from: {
        //         x: '0%'
        //     },
        //     to: {
        //         x: '-100%' 
        //     },
        //     config: {
        //         duration: 1000,
        //         easing: easings.easeOutQuart
        //       },
        // })

        ansClickSet(val);

        ansDisableSet(true);

        setTimeout(() => {
            ans.current.push(val);

            document.activeElement.blur();

            refSet(ref + 1);

            if (step == qz.current.length) {
                setTimeout(() => {
                    Fin();
                }, 100);
            }
        }, 1000);

    }

    function ShowFullImg(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <img
                    src={store.img[fimg]}
                    onClick={() => { showFimgSet(false) }}
                    style={{
                        cursor: 'pointer',
                        objectFit: 'cover',
                        width: '100%'
                    }}
                />
            </Modal>
        );
    }

    const imgStyle = {
        cursor: 'pointer',
        objectFit: 'cover',
        height: '350px',
        width: '100%'
    }
    function Fin() {

        const user = localStorage.getItem('uuid');
        const nick = localStorage.getItem('nick');
        const sex = localStorage.getItem('gender');

        if (!user || !nick || !sex) {
            pfModalSet(true);
            return;
        }

        axios.post(Static.SvrAddr + 'fin', {
            game: uid,
            user: user,
            nick: nick,
            sex: sex,
            ans: ans.current,
        }).then((res) => {
            console.log(res);

            const isLegacyFinResponse = Array.isArray(res.data?.[0]);
            const finResult = isLegacyFinResponse ? res.data?.[1]?.[0] : res.data?.[0];
            const resultMsg = finResult?.res;
            const fcmUsers = isLegacyFinResponse ? (res.data?.[2] || []) : (res.data?.[1] || []);
            const savedUser = finResult?.user || finResult?.User_uid || res.data?.[0]?.[0]?.user || null;

            if (savedUser) {
                localStorage.setItem('uuid', savedUser);
            }

            if (localStorage.getItem('id') == null) {
                localStorage.setItem('id', localStorage.getItem('nick'));
            }

            localStorage.setItem('noti', 'set');

            let msg = resultMsg;

            if (msg == 'over') {
                alert("게임이 종료되어 이젠 참여하지 못해요.");
            }
            else if (msg == 'fcm') {
                let tkns = [];
                fcmUsers.map((d, i) => {
                    if (d.fcm != null) {
                        tkns.push(d.fcm);
                    }
                })

                axios.post(Static.SvrAddr + 'fcm', {
                    tkn: tkns,
                    title: store.game.title,
                    gid: uid
                }).then((res2) => {
                    console.log(res2);
                }).catch(() => {
                    console.log('실패함');
                })
            }

            navigate('/game/' + uid, { replace: true });

            let t = (new Date().getTime() - startTime.current) / 1000;
            ReactGA.event('done_game', { '플레이문제수': qz.current.length, '플레이시간': t.toFixed(0) });

        }).catch(() => {
            console.log('실패함');
        })
    }

    function ProfileModal() {
        return (
            <ModalEditPf
                show={pfModal}
                handleClose={() => { pfModalSet(false) }}
                playmod={false}
                sexmod={true}
                cpmod={true}
                cb={() => { Fin() }}
            />
        )
    }

    function GetStepBar(step, max) {
        let bar = [];
        for (let i = 0; i < max; i++) {
            let now = i == step - 1;
            let col = i < step ? 'text-bg-primary' : 'bg-light';
            bar.push(
                now ? (
                    <animated.div className={col}
                        key={i}
                        style={{
                            flex: 1,
                            borderRadius: 5,
                            ...aniNowBar
                        }}
                    />
                ) : (
                    <div className={col}
                        key={i}
                        style={{
                            flex: 1,
                            borderRadius: 5,
                        }}
                    />
                )
            );
        }
        return bar;
    };



    if (!qz.current) {
        return ShowLoading()
    }
    if (qz.current.length == 0) {
        return ShowLoading()
    }
    if (idx == qz.current.length) {

        return (
            <div className='fs-2 text-center'>
                <img src={ImgPlayDone} style={{ height: '400px' }} />
                <ProfileModal />
            </div>
        )

    }
    return (
        <div className='p-3 d-flex flex-column' style={{ width: '100%', height: '100%' }}>

            <div className='fs-5'>
                {store.game.title}
            </div>

            <div style={{ padding: '0 10px' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end'
                }}>
                    <span style={{
                        fontSize: '18px',
                        color: '#212529',
                        fontWeight: 'bold'
                    }}>{`${step}`}</span>
                    <span style={{
                        fontSize: '12px',
                        color: '#6c757d'
                    }}>{` /${qz.current.length}`}</span>
                </div>
                <div style={{
                    flex: 1,
                    minHeight: '7px',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                    marginBottom: '30px'
                }}>
                    {GetStepBar(step, qz.current.length)}
                </div>
            </div>

            <fieldset disabled={ansDisable}>
                <div className='d-flex flex-column justify-content-center flex-grow-1'>
                    <div className='fs-3'>
                        {qz.current[idx][0]}
                    </div>
                    <div className='d-flex p-1'>
                        <animated.div className='col-6 p-1 d-flex flex-column gap-1' style={{ ...aniSlot1 }}>
                            {
                                imgA != null && (
                                    imgA == ImgNull ? (
                                        <img className='rounded-3' src={ImgNull} style={imgStyle} />
                                    ) : (
                                        <ImgSlot
                                            imgKey={imgA}
                                            className='rounded-3'
                                            style={imgStyle}
                                            onClick={() => { fimgSet(imgA); showFimgSet(true); }}
                                        />
                                    )
                                )
                            }
                            <button className={GetBtnClass(1, imgA != null)} onClick={() => { ClickAns(1) }}>
                                {qz.current[idx][1]}
                            </button>
                        </animated.div>

                        <animated.div className='col-6 p-1 d-flex flex-column gap-1' style={{ ...aniSlot2 }}>
                            {
                                imgB != null && (
                                    imgB == ImgNull ? (
                                        <img className='rounded-3' src={ImgNull} style={imgStyle} />
                                    ) : (
                                        <ImgSlot
                                            imgKey={imgB}
                                            className='rounded-3'
                                            style={imgStyle}
                                            onClick={() => { fimgSet(imgB); showFimgSet(true); }}
                                        />
                                    )
                                )
                            }

                            <button className={GetBtnClass(2, imgB != null)} onClick={() => { ClickAns(2) }}>
                                {qz.current[idx][2]}
                            </button>
                        </animated.div>
                    </div>
                </div>
            </fieldset>

            <div className='my-3'>
                <Adsense type={'ia'} />
            </div>


            <ShowFullImg
                show={showFimg}
                onHide={() => showFimgSet(false)}
            />

            <ProfileModal />


        </div >

    )
}



export default Play;
